import { render, staticRenderFns } from "./emailCampaignDialog.vue?vue&type=template&id=3bae52bc&lang=pug"
import script from "./emailCampaignDialog.vue?vue&type=script&lang=js"
export * from "./emailCampaignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports